export default "__VITE_ASSET__CRcMcDpB__"